import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClaimSearchTypeEnum } from '../../shared/enums/claim-search-type.enum';
import { skipGlobalErrorToast } from '../../common/http/skip-global-error.token';

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  private readonly http = inject(HttpClient);

  public createDamageEntriesReport(params: {
    dateFrom: string;
    dateTo: string;
    countryIds?: number[];
    surveyPointIds?: number[];
    processPartnerIds?: number[];
    processPartnerSearch?: ClaimSearchTypeEnum | 'CAUSER';
  }): Observable<{ presignedUrl: string }> {
    return this.http.post<{ presignedUrl: string }>(
      `${environment.services.masterdata}/api/damage-entries/report`,
      params,
      { context: skipGlobalErrorToast() }
    );
  }

  public createClaimHandlingReport(params: {
    dateFrom: string;
    dateTo: string;
    countryIds?: number[];
    surveyPointIds?: number[];
    processPartnerIds?: number[];
    processPartnerSearch?: ClaimSearchTypeEnum | 'CAUSER';
  }): Observable<{ presignedUrl: string }> {
    return this.http.post<{ presignedUrl: string }>(
      `${environment.services.masterdata}/api/claim-handling/report`,
      params,
      { context: skipGlobalErrorToast() }
    );
  }
}
